import HomeView from '@/views/HomeView.vue'
import UsersView from '@/views/UsersView.vue'
import LocationView from '@/views/LocationView.vue'
import LoginView from '@/views/LogInView.vue'
import ResetView from '@/views/ResetView.vue'
import LaunchView from '@/views/LaunchView.vue'
import ConfigView from '@/views/ConfigView.vue'
import InsuranceView from '@/views/InsuranceView.vue'
import WasabiView from '@/views/WasabiView.vue'
import AdasMatrixView from '@/views/AdasMatrixView.vue'
import ToolsView from '@/views/ToolsView.vue'
import AccessRequestsView from '@/views/AccessRequestsView.vue'
import AppPricingView from '@/views/AppPricingView.vue'
import AppUsageView from '@/views/AppUsageView.vue'
export default [
  {
    path: '/login',
    name: 'login',
    meta: { allowAnonymous: true },
    component: LoginView
  },
  {
    path: '/reset',
    name: 'reset',
    meta: { allowAnonymous: true },
    component: ResetView
  },
  {
    path: '/',
    name: 'home',
    meta: { layout: 'side-nav' },
    component: HomeView
  },
  {
    path: '/users',
    name: 'users',
    meta: { layout: 'default' },
    component: UsersView
  },
  {
    path: '/locations',
    name: 'locations',
    meta: { layout: 'default' },
    component: LocationView
  },
  {
    path: '/launchpad',
    name: 'launchpad',
    meta: { layout: 'default' },
    component: LaunchView
  },
  {
    path: '/configuration',
    name: 'configuration',
    meta: { layout: 'default' },
    component: ConfigView
  },
  {
    path: '/insurance',
    name: 'insurance',
    meta: { layout: 'default' },
    component: InsuranceView
  },
  {
    path: '/wasabi',
    name: 'wasabi',
    meta: { layout: 'default' },
    component: WasabiView
  },
  {
    path: '/adasmatrix',
    name: 'adasmatrix',
    meta: { layout: 'default' },
    component: AdasMatrixView
  },
  {
    path: '/tools',
    name: 'tools',
    meta: { layout: 'default' },
    component: ToolsView
  },
  {
    path: '/access-requests',
    name: 'access-requests',
    meta: { layout: 'default' },
    component: AccessRequestsView
  },
  {
    path: '/app-pricing',
    name: 'app-pricing',
    meta: { layout: 'default' },
    component: AppPricingView
  },
  {
    path: '/app-usage',
    name: 'app-usage',
    meta: { layout: 'default' },
    component: AppUsageView
  },
  {
    path: '/about',
    name: 'about',
    meta: { layout: 'default' },
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/AboutView.vue')
  }
]
